import { useQuery } from "react-query";
import criterionClassDiscipline from "./services"

export const useCriterionClassDiscipline = (
    criterionClassDisciplineId: number
) => (
    useQuery(
        ['criterion-class-discipline', criterionClassDisciplineId],
        (key: string, id: number) => {
            if (id) {
                return criterionClassDiscipline.get(id)
            }
            return Promise.resolve(null)
        },
        { refetchOnMount: false, refetchOnWindowFocus: false }
    )
)
